const u = up.util;
up.RenderOptions = (function () {
    const NO_PREVIEWS = {
        preview: false,
        disable: false,
        placeholder: false,
        feedback: false,
    };
    const NO_INPUT_INTERFERENCE = {
        scroll: false,
        focus: 'keep',
        confirm: false,
    };
    const NO_MOTION = {
        transition: false,
        animation: false,
        openAnimation: false,
        closeAnimation: false,
    };
    const PREFLIGHT_KEYS = [
        'url',
        'method',
        'origin',
        'headers',
        'params',
        'cache',
        'fallback',
        'abort',
        'abortable',
        'handleAbort',
        'confirm',
        'feedback',
        'disable',
        'placeholder',
        'preview',
        'origin',
        'originLayer',
        'baseLayer',
        'navigate',
        'fail',
        'onError',
    ];
    const SHARED_KEYS = PREFLIGHT_KEYS.concat([
        'keep',
        'hungry',
        'history',
        'source',
        'saveScroll',
    ]);
    const CONTENT_KEYS = [
        'url',
        'response',
        'content',
        'fragment',
        'document',
    ];
    const LATE_KEYS = [
        'history',
        'focus',
        'scroll',
    ];
    const EVENT_CALLBACK = {};
    const RESULT_CALLBACK = { argNames: ['result'] };
    const ERROR_CALLBACK = { argNames: ['error'] };
    const OPEN_LAYER_CALLBACK = { expandObject: ['layer'] };
    const CLOSE_LAYER_CALLBACK = { expandObject: ['layer', 'value', 'response'] };
    const CALLBACKS = {
        onLoaded: EVENT_CALLBACK,
        onRendered: RESULT_CALLBACK,
        onFinished: RESULT_CALLBACK,
        onOffline: ERROR_CALLBACK,
        onError: ERROR_CALLBACK,
        onOpened: OPEN_LAYER_CALLBACK,
        onDismissed: CLOSE_LAYER_CALLBACK,
        onAccepted: CLOSE_LAYER_CALLBACK,
    };
    function parseCallback(key, code) {
        return up.script.parseCallback(code, parseCallbackOptions(key));
    }
    function parseCallbackOptions(key) {
        return CALLBACKS[key] ?? up.fail(`Unknown callback { ${key} }`);
    }
    function callbackAttr(element, attrName, key) {
        return up.script.callbackAttr(element, attrName, parseCallbackOptions(key));
    }
    function navigateDefaults(options) {
        if (options.navigate) {
            return up.fragment.config.navigateOptions;
        }
    }
    function normalizeURL({ url }) {
        if (url) {
            return { url: u.normalizeURL(url) };
        }
    }
    function removeUsePrefix(options) {
        u.renameKey(options, 'useData', 'data');
        u.renameKey(options, 'useHungry', 'hungry');
        u.renameKey(options, 'useKeep', 'keep');
    }
    function preprocess(options) {
        up.migrate.preprocessRenderOptions?.(options);
        up.layer.normalizeOptions(options);
        removeUsePrefix(options);
        const defaults = u.merge(up.fragment.config.renderOptions, navigateDefaults(options));
        return u.merge(u.omit(defaults, LATE_KEYS), { defaults }, { inputDevice: up.event.inputDevice }, options, normalizeURL(options), rememberOriginLayer(options));
    }
    function rememberOriginLayer({ origin, originLayer }) {
        if (origin && !originLayer) {
            return {
                originLayer: up.layer.get(origin),
            };
        }
    }
    function finalize(preprocessedOptions, lateDefaults) {
        return u.merge(preprocessedOptions.defaults, lateDefaults, preprocessedOptions);
    }
    function assertContentGiven(options) {
        if (!u.some(CONTENT_KEYS, (contentKey) => u.isGiven(options[contentKey]))) {
            if (options.defaultToEmptyContent) {
                options.content = '';
            }
            else {
                up.fail('up.render() needs either { ' + CONTENT_KEYS.join(', ') + ' } option');
            }
        }
    }
    function failOverrides(options) {
        const overrides = {};
        for (let key in options) {
            const value = options[key];
            let unprefixed = up.fragment.successKey(key);
            if (unprefixed) {
                overrides[unprefixed] = value;
            }
        }
        return overrides;
    }
    function deriveFailOptions(preprocessedOptions) {
        let markFailure = { didFail: true };
        let overrides = failOverrides(preprocessedOptions);
        if (preprocessedOptions.failOptions) {
            return {
                ...preprocessedOptions.defaults,
                ...u.pick(preprocessedOptions, SHARED_KEYS),
                ...overrides,
                didForceFailOptions: true,
                ...markFailure,
            };
        }
        else {
            return {
                ...preprocessedOptions,
                ...overrides,
                ...markFailure,
            };
        }
    }
    return {
        preprocess,
        finalize,
        assertContentGiven,
        deriveFailOptions,
        parseCallback,
        callbackAttr,
        NO_PREVIEWS,
        NO_MOTION,
        NO_INPUT_INTERFERENCE,
    };
})();
